module.exports = __webpack_public_path__ + "static/media/medal-star.394816ad.svg";